import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-edbf92e6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: `outside-iframe ${_ctx.isPhone ? 'phone' : ''}`
      }, [
        _createVNode("iframe", {
          src: _ctx.url,
          onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.iframeLoad && _ctx.iframeLoad(...args)))
        }, null, 40, ["src"])
      ], 2))
    : _createCommentVNode("", true)
})